import { SkeletonLoader } from '@/shared/ui/skeleton/skeleton';
import { SlideWrapperBound } from '@/features/news-management/styles';

export const BannerSkeleton = () => (
  <SlideWrapperBound>
    <SkeletonLoader height="100%" />
  </SlideWrapperBound>
);
